<script>
    import TextField from "./TextField.svelte";
    import NumberField from "../form/NumberField.svelte";
    import Slider from "./Slider.svelte";

    import { fade, fly } from 'svelte/transition';

    export let marketAnnualSalary = 30000;
    export let hourlySalary = 50;
    export let rateTypeIsAnnually = false;
</script>

<a href="#" class="rate-type-switcher" on:click|preventDefault={() => rateTypeIsAnnually = !rateTypeIsAnnually}>
    view {!rateTypeIsAnnually ? 'yearly' : 'hourly'}
</a>

<div class="rate-type-fields">

    <div class="rate-type-field {!rateTypeIsAnnually ? 'show' : 'hide'}" in:fly="{{ x: -50, duration: 750 }}" out:fly="{{ x: 50, duration: 750 }}">
        <TextField bind:value={hourlySalary}
                   style="width: 100%"
                   placeholder="50"
                   label="Hourly salary"
                   help="What this participant would earn hourly if employed/contracted"
                   type="number" />
    </div>

    <div class="rate-type-field {rateTypeIsAnnually ? 'show' : 'hide'}" in:fly="{{ x: 50, duration: 750 }}" out:fly="{{ x: -50, duration: 750 }}">
<!--        <Slider-->
<!--                min={1}-->
<!--                max={50000}-->
<!--                bind:value={marketAnnualSalary}-->

<!--                step={100}-->
<!--                label="Yearly market salary"-->
<!--                help={"What this coworker would earn every year if employed on contract. Currently: €" + marketAnnualSalary}-->
<!--        />-->

        <NumberField
                bind:value={marketAnnualSalary}
                fullwidth
                label="Yearly salary"
                placeholder="20000"
                step={1}
                help={"What this participant would earn every year if employed on contract. Currently: €" + marketAnnualSalary}

        />
    </div>
</div>

<style>
    .rate-type-switcher {
       display: block;
       text-align: right;
       font-size: 11px;
       cursor: pointer;
       margin-bottom: 4px;
    }

    .rate-type-fields {
        //overflow: hidden;
    }

    .rate-type-field {
        display: inline-block;
        width: 100%;
    }

    .rate-type-field.hide {
        display: none;
    }
</style>